export class Filter {
    value: string;
    label: string;
    parentId?: string;
    checked?: boolean;
}

export class MesAnioSelected {
  mesdesde: number;
  aniodesde: number;
  meshasta: number;
  aniohasta: number;
}
